import ChildEntity from "@Shared/Entities/AbstractEntities/ChildEntity";
import { Network } from "@Shared/Entities/Customer/Usage/enums";
import constraints from "./constraints";
import { BillingRelationship, Effected, MDMNames, TimePeriods, } from "./enums";
import migrate from "./migrate";
export default class Proposal extends ChildEntity {
    constructor(data = {}) {
        super(migrate(data), constraints);
    }
    get data() {
        const { bundles, progress, totalFund, hwFundTaken, cashHW, drawDown, deductSims, handsetProfitMargin, handsetLocked, appleDEP, networkVariant, deliveryCharge, reducedEffect, OS, additionalLinesCoTerminus, timeLeftTerm, hwFundPerLine, hwFundPerDataSim, otherNetwork, additionalLinesInfo, HWProRata, additionalInfo, accountManaged, complaintProcess, ticketSystem, responseTime, resolutionTime, freeNextDay, ongoingAnalysis, offeringPlanCom, ongoingAnalysisMethod, analysisFrequency, disposeHandsets, WEEECertificates, fullRecycleValue, PACCodeCharge, chargeMethod, PACCost, customTerms, terminationPenalty, penaltyPerLine, paperStatements, costForStatements, nonDirectDebitCharges, nonDirectDebitCost, extraChargesInTenders, totalMonthlyCost, isCloudFree, MDMLineCost, offerMDM, MDMName, MDMDetails, MDMOS, otherName, minCommitmentPeriod, minCommitmentPeriodOther, MDMRange, enterpriseVersions, alternativeSolution, furtherMDM, multipleNetworks, selectNetworks, secondaryNetworks, billingRelationship, networkRelationship, billingRelationshipChoice, keepSims, VIPService, VIPServiceResponseTime, increases, additionalNetworkInfo, increaseMeasurement, additionalIncrease, percentageIncrease, breakClause, tariffComponents, proposalDependant, eSims, networkSupport, isManagementFee, managementFeeChargeMethod, managementFee, minimumSpend, hasMinimumSpend, reducedHWFund, changesOrRequirements, ukIDDToEurope, ukIDDToROW, ukIDDToUSAandCanada, ukIDDToAPAC, ukToInternational, pictureMsg, chargeable08, UKUsageUkIDDToEurope, UKUsageUkIDDToROW, UKUsageUkIDDToUSAandCanada, UKUsageUkIDDToAPAC, UKUsageUkToInternational, UKUsagePictureMsg, UKUsageChargeable08, rackRate, planName, devicePrices, offerLeasing, setupFee, monthlyLeasing, leasingData, leasingLumpSum, leasingNotes, deductedPerSim, simCost, accountManagerVisit, accountManagerVisitFrequency, additionalChargeDetails, discount, deviceInsurance, chargeForDelivery, extraDeviceDetails, deliveryChargeMethod, minimumLeaseTerm, leasingRequiresInsurance, directDebit, directDebitCost, mandatoryRise, additionalIncreasePercentage, mandatoryRisePercentage, chargePerSim, offerDM, dmTool, DMOS, dmFeatures, dmFree, dmLineCost, dmMinCommitmentPeriod, dmMinCommitmentPeriodOther, dmRange, dmEnterprise, dmAlternative, additionalData, additionalLines, } = this;
        const { version } = this._data;
        return {
            version,
            progress,
            totalFund,
            hwFundTaken,
            cashHW,
            drawDown,
            deductSims,
            handsetProfitMargin,
            handsetLocked,
            appleDEP,
            networkVariant,
            deliveryCharge,
            reducedEffect,
            OS,
            additionalLinesCoTerminus,
            timeLeftTerm,
            hwFundPerLine,
            hwFundPerDataSim,
            otherNetwork,
            additionalLinesInfo,
            HWProRata,
            additionalInfo,
            accountManaged,
            complaintProcess,
            ticketSystem,
            responseTime,
            resolutionTime,
            freeNextDay,
            ongoingAnalysis,
            offeringPlanCom,
            ongoingAnalysisMethod,
            analysisFrequency,
            disposeHandsets,
            WEEECertificates,
            fullRecycleValue,
            PACCodeCharge,
            chargeMethod,
            PACCost,
            customTerms,
            terminationPenalty,
            penaltyPerLine,
            paperStatements,
            costForStatements,
            nonDirectDebitCharges,
            nonDirectDebitCost,
            extraChargesInTenders,
            totalMonthlyCost,
            isCloudFree,
            MDMLineCost,
            MDMName,
            MDMDetails,
            MDMOS,
            otherName,
            offerMDM,
            minCommitmentPeriod,
            MDMRange,
            enterpriseVersions,
            alternativeSolution,
            furtherMDM,
            multipleNetworks,
            selectNetworks,
            secondaryNetworks,
            billingRelationship,
            billingRelationshipChoice,
            networkRelationship,
            keepSims,
            VIPService,
            VIPServiceResponseTime,
            increases,
            additionalNetworkInfo,
            increaseMeasurement,
            additionalIncrease,
            percentageIncrease,
            breakClause,
            tariffComponents,
            proposalDependant,
            eSims,
            networkSupport,
            isManagementFee,
            managementFeeChargeMethod,
            managementFee,
            minimumSpend,
            hasMinimumSpend,
            reducedHWFund,
            changesOrRequirements,
            ukIDDToEurope,
            ukIDDToROW,
            ukIDDToUSAandCanada,
            ukIDDToAPAC,
            ukToInternational,
            pictureMsg,
            chargeable08,
            UKUsageUkIDDToEurope,
            UKUsageUkIDDToROW,
            UKUsageUkIDDToUSAandCanada,
            UKUsageUkIDDToAPAC,
            UKUsageUkToInternational,
            UKUsagePictureMsg,
            UKUsageChargeable08,
            bundles,
            rackRate,
            planName,
            devicePrices,
            offerLeasing,
            setupFee,
            monthlyLeasing,
            leasingData,
            leasingLumpSum,
            leasingNotes,
            deductedPerSim,
            simCost,
            accountManagerVisit,
            accountManagerVisitFrequency,
            additionalChargeDetails,
            discount,
            deviceInsurance,
            chargeForDelivery,
            extraDeviceDetails,
            deliveryChargeMethod,
            minimumLeaseTerm,
            leasingRequiresInsurance,
            directDebit,
            directDebitCost,
            mandatoryRise,
            additionalIncreasePercentage,
            mandatoryRisePercentage,
            minCommitmentPeriodOther,
            chargePerSim,
            offerDM,
            dmTool,
            DMOS,
            dmFeatures,
            dmFree,
            dmLineCost,
            dmMinCommitmentPeriod,
            dmMinCommitmentPeriodOther,
            dmRange,
            dmEnterprise,
            dmAlternative,
            additionalData,
            additionalLines,
        };
    }
    get(k) {
        return this.data[k];
    }
    //Tariff
    get planName() {
        return this._data.planName;
    }
    get tariffComponents() {
        return this._data.tariffComponents || [];
    }
    get discount() {
        return this._data.discount || 0;
    }
    get proposalDependant() {
        return this._data.proposalDependant;
    }
    get changesOrRequirements() {
        if (this.proposalDependant !== true) {
            return undefined;
        }
        return this._data.changesOrRequirements;
    }
    get eSims() {
        return this._data.eSims;
    }
    get networkSupport() {
        return this._data.networkSupport;
    }
    get isManagementFee() {
        return this._data.isManagementFee;
    }
    get managementFeeChargeMethod() {
        if (this.isManagementFee !== true) {
            return undefined;
        }
        return this._data.managementFeeChargeMethod;
    }
    get managementFee() {
        if (this.isManagementFee !== true) {
            return undefined;
        }
        return this._data.managementFee;
    }
    get hasMinimumSpend() {
        return this._data.hasMinimumSpend;
    }
    get minimumSpend() {
        if (this.hasMinimumSpend !== true) {
            return undefined;
        }
        return this._data.minimumSpend;
    }
    get reducedHWFund() {
        if (this.hasMinimumSpend !== true) {
            return undefined;
        }
        return this._data.reducedHWFund;
    }
    get reducedEffect() {
        if (this.reducedHWFund !== true) {
            return undefined;
        }
        return this._data.reducedEffect;
    }
    //OOB
    get bundles() {
        return this._data[Effected.Bundles] || [];
    }
    get rackRate() {
        return this._data.rackRate;
    }
    //Hardware Fund
    get totalFund() {
        return this._data.totalFund;
    }
    get cashHW() {
        if (this.totalFund === 0) {
            return undefined;
        }
        return this._data.cashHW;
    }
    get hwFundTaken() {
        if (this.cashHW !== true) {
            return undefined;
        }
        return this._data.hwFundTaken;
    }
    get drawDown() {
        if (this.totalFund === 0) {
            return undefined;
        }
        return this._data.drawDown;
    }
    get deductSims() {
        if (this.totalFund === 0) {
            return undefined;
        }
        return this._data.deductSims;
    }
    get deductedPerSim() {
        if (this.deductSims !== true) {
            return undefined;
        }
        return this._data.deductedPerSim;
    }
    get simCost() {
        if (this.totalFund !== 0) {
            return undefined;
        }
        return this._data.simCost;
    }
    get chargePerSim() {
        if (this.simCost !== true) {
            return undefined;
        }
        return this._data.chargePerSim;
    }
    get devicePrices() {
        return this._data.devicePrices || [];
    }
    get offerLeasing() {
        return this._data.offerLeasing;
    }
    get setupFee() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.setupFee;
    }
    get minimumLeaseTerm() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.minimumLeaseTerm;
    }
    get leasingData() {
        const leasingData = this._data.leasingData || [];
        if (this.offerLeasing !== true && leasingData !== undefined) {
            return leasingData.map(({ deviceId, latestId }) => ({
                deviceId,
                latestId,
            }));
        }
        return leasingData;
    }
    get leasingRequiresInsurance() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.leasingRequiresInsurance;
    }
    get directDebit() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.directDebit;
    }
    get directDebitCost() {
        if (this.directDebit !== true) {
            return undefined;
        }
        return this._data.directDebitCost;
    }
    get leasingLumpSum() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.leasingLumpSum;
    }
    get leasingNotes() {
        if (this.offerLeasing !== true) {
            return undefined;
        }
        return this._data.leasingNotes;
    }
    get handsetProfitMargin() {
        return this._data.handsetProfitMargin;
    }
    get appleDEP() {
        return this._data.appleDEP;
    }
    get deviceInsurance() {
        return this._data.deviceInsurance;
    }
    get chargeForDelivery() {
        return this._data.chargeForDelivery;
    }
    get deliveryChargeMethod() {
        if (this.chargeForDelivery !== true) {
            return undefined;
        }
        return this._data.deliveryChargeMethod;
    }
    get deliveryCharge() {
        if (this.chargeForDelivery !== true) {
            return undefined;
        }
        return Number.isNaN(this._data.deliveryCharge)
            ? 0
            : Number(this._data.deliveryCharge);
    }
    get extraDeviceDetails() {
        return this._data.extraDeviceDetails;
    }
    //Network
    get multipleNetworks() {
        return this._data.multipleNetworks;
    }
    get selectNetworks() {
        if (this.multipleNetworks !== true) {
            return undefined;
        }
        return this._data.selectNetworks;
    }
    get otherNetwork() {
        if (this.selectNetworks === undefined ||
            !this.selectNetworks.includes(Network.Other)) {
            return undefined;
        }
        return this._data.otherNetwork;
    }
    get billingRelationship() {
        return this._data.billingRelationship;
    }
    get billingRelationshipChoice() {
        if (this.billingRelationship !== BillingRelationship.Both) {
            return undefined;
        }
        return this._data.billingRelationshipChoice;
    }
    get networkRelationship() {
        return this._data.networkRelationship;
    }
    get keepSims() {
        return this._data.keepSims;
    }
    get increases() {
        return this._data.increases;
    }
    get increaseMeasurement() {
        if (this.increases !== true) {
            return undefined;
        }
        return this._data.increaseMeasurement;
    }
    get additionalIncrease() {
        if (this.increases !== true) {
            return undefined;
        }
        return this._data.additionalIncrease;
    }
    get additionalIncreasePercentage() {
        if (this.additionalIncrease !== true) {
            return undefined;
        }
        return this._data.additionalIncreasePercentage;
    }
    get breakClause() {
        if (this.increases !== true) {
            return undefined;
        }
        return this._data.breakClause;
    }
    get mandatoryRise() {
        if (this.increases !== true) {
            return undefined;
        }
        return this._data.mandatoryRise;
    }
    get mandatoryRisePercentage() {
        if (this.mandatoryRise !== true) {
            return undefined;
        }
        return this._data.mandatoryRisePercentage;
    }
    get additionalNetworkInfo() {
        return this._data.additionalNetworkInfo;
    }
    //Additional Lines
    get additionalLinesCoTerminus() {
        return this._data.additionalLinesCoTerminus;
    }
    get timeLeftTerm() {
        if (this.additionalLinesCoTerminus !== true) {
            return undefined;
        }
        return this._data.timeLeftTerm;
    }
    get hwFundPerLine() {
        return this._data.hwFundPerLine;
    }
    get hwFundPerDataSim() {
        return this._data.hwFundPerDataSim;
    }
    get HWProRata() {
        if (this.additionalLinesCoTerminus !== true) {
            return undefined;
        }
        return this._data.HWProRata;
    }
    get additionalLinesInfo() {
        return this._data.additionalLinesInfo;
    }
    //MDM
    get offerMDM() {
        return this._data.offerMDM;
    }
    get MDMName() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.MDMName;
    }
    get MDMDetails() {
        if (this.MDMName === undefined || this.MDMName === MDMNames.Other) {
            return undefined;
        }
        return this._data.MDMDetails;
    }
    get otherName() {
        if (this.MDMName !== MDMNames.Other) {
            return undefined;
        }
        return this._data.otherName;
    }
    get MDMOS() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.MDMOS;
    }
    get isCloudFree() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.isCloudFree;
    }
    get MDMLineCost() {
        if (this.offerMDM !== true || this.isCloudFree === true) {
            return undefined;
        }
        return this._data.MDMLineCost;
    }
    get minCommitmentPeriod() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.minCommitmentPeriod;
    }
    get minCommitmentPeriodOther() {
        if (this.minCommitmentPeriod !== TimePeriods.Other) {
            return undefined;
        }
        return this._data.minCommitmentPeriodOther;
    }
    get MDMRange() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.MDMRange;
    }
    get enterpriseVersions() {
        if (this.MDMRange !== true) {
            return undefined;
        }
        return this._data.enterpriseVersions;
    }
    get alternativeSolution() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.alternativeSolution;
    }
    get furtherMDM() {
        if (this.offerMDM !== true) {
            return undefined;
        }
        return this._data.furtherMDM;
    }
    //DM
    get offerDM() {
        return this._data.offerDM;
    }
    get dmTool() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.dmTool;
    }
    get DMOS() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.DMOS;
    }
    get dmFeatures() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.dmFeatures;
    }
    get dmFree() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.dmFree;
    }
    get dmLineCost() {
        if (this.offerDM !== true || this.dmFree === true) {
            return undefined;
        }
        return this._data.dmLineCost;
    }
    get dmMinCommitmentPeriod() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.dmMinCommitmentPeriod;
    }
    get dmMinCommitmentPeriodOther() {
        if (this.dmMinCommitmentPeriod !== TimePeriods.Other) {
            return undefined;
        }
        return this._data.dmMinCommitmentPeriodOther;
    }
    get dmRange() {
        if (this.offerDM !== true) {
            return undefined;
        }
        return this._data.dmRange;
    }
    get dmEnterprise() {
        if (this.dmRange !== true) {
            return undefined;
        }
        return this._data.dmEnterprise;
    }
    get dmAlternative() {
        return this._data.dmAlternative;
    }
    //Customer Service
    get accountManaged() {
        return this._data.accountManaged;
    }
    get accountManagerVisit() {
        if (this.accountManaged !== true) {
            return undefined;
        }
        return this._data.accountManagerVisit;
    }
    get accountManagerVisitFrequency() {
        if (this.accountManagerVisit !== true) {
            return undefined;
        }
        return this._data.accountManagerVisitFrequency;
    }
    get complaintProcess() {
        return this._data.complaintProcess;
    }
    get ticketSystem() {
        return this._data.ticketSystem;
    }
    get VIPService() {
        return this._data.VIPService;
    }
    get VIPServiceResponseTime() {
        if (this.VIPService !== true) {
            return undefined;
        }
        return this._data.VIPServiceResponseTime;
    }
    get responseTime() {
        if (this.VIPService === true) {
            return undefined;
        }
        return this._data.responseTime;
    }
    get resolutionTime() {
        return this._data.resolutionTime;
    }
    get freeNextDay() {
        return this._data.freeNextDay;
    }
    get ongoingAnalysis() {
        return this._data.ongoingAnalysis;
    }
    get analysisFrequency() {
        if (this.ongoingAnalysis !== true) {
            return undefined;
        }
        return this._data.analysisFrequency;
    }
    get ongoingAnalysisMethod() {
        if (this.ongoingAnalysis !== true) {
            return undefined;
        }
        return this._data.ongoingAnalysisMethod;
    }
    get disposeHandsets() {
        return this._data.disposeHandsets;
    }
    get WEEECertificates() {
        if (this.disposeHandsets !== true) {
            return undefined;
        }
        return this._data.WEEECertificates;
    }
    get fullRecycleValue() {
        if (this.disposeHandsets !== true) {
            return undefined;
        }
        return this._data.fullRecycleValue;
    }
    get customTerms() {
        return this._data.customTerms;
    }
    get PACCodeCharge() {
        return this._data.PACCodeCharge;
    }
    get chargeMethod() {
        if (this.PACCodeCharge !== true) {
            return undefined;
        }
        return this._data.chargeMethod;
    }
    get PACCost() {
        if (this.PACCodeCharge !== true) {
            return undefined;
        }
        return this._data.PACCost;
    }
    get terminationPenalty() {
        return this._data.terminationPenalty;
    }
    get penaltyPerLine() {
        if (this.terminationPenalty !== true) {
            return undefined;
        }
        return this._data.penaltyPerLine;
    }
    get paperStatements() {
        return this._data.paperStatements;
    }
    get costForStatements() {
        if (this.paperStatements !== true) {
            return undefined;
        }
        return this._data.costForStatements;
    }
    get nonDirectDebitCharges() {
        return this._data.nonDirectDebitCharges;
    }
    get nonDirectDebitCost() {
        if (this.nonDirectDebitCharges !== true) {
            return undefined;
        }
        return this._data.nonDirectDebitCost;
    }
    get extraChargesInTenders() {
        return this._data.extraChargesInTenders;
    }
    get additionalChargeDetails() {
        if (this.extraChargesInTenders !== true) {
            return undefined;
        }
        return this._data.additionalChargeDetails;
    }
    get totalMonthlyCost() {
        if (this.extraChargesInTenders !== true) {
            return undefined;
        }
        return this._data.totalMonthlyCost;
    }
    //extra
    get progress() {
        return this._data.progress;
    }
    get handsetLocked() {
        return this._data.handsetLocked;
    }
    get networkVariant() {
        return this._data.networkVariant;
    }
    get OS() {
        return this._data.OS;
    }
    get additionalInfo() {
        return this._data.additionalInfo;
    }
    get offeringPlanCom() {
        return this._data.offeringPlanCom;
    }
    get secondaryNetworks() {
        return this._data.secondaryNetworks;
    }
    get ukIDDToEurope() {
        return this._data.ukIDDToEurope;
    }
    get ukIDDToROW() {
        return this._data.ukIDDToROW;
    }
    get ukIDDToUSAandCanada() {
        return this._data.ukIDDToUSAandCanada;
    }
    get ukIDDToAPAC() {
        return this._data.ukIDDToAPAC;
    }
    get ukToInternational() {
        return this._data.ukToInternational;
    }
    get pictureMsg() {
        return this._data.pictureMsg;
    }
    get chargeable08() {
        return this._data.chargeable08;
    }
    get UKUsageUkIDDToEurope() {
        return this._data.UKUsageUkIDDToEurope;
    }
    get UKUsageUkIDDToROW() {
        return this._data.UKUsageUkIDDToROW;
    }
    get UKUsageUkIDDToUSAandCanada() {
        return this._data.UKUsageUkIDDToUSAandCanada;
    }
    get UKUsageUkIDDToAPAC() {
        return this._data.UKUsageUkIDDToAPAC;
    }
    get UKUsageUkToInternational() {
        return this._data.UKUsageUkToInternational;
    }
    get UKUsagePictureMsg() {
        return this._data.UKUsagePictureMsg;
    }
    get UKUsageChargeable08() {
        return this._data.UKUsageChargeable08;
    }
    get monthlyLeasing() {
        return this._data.monthlyLeasing;
    }
    get percentageIncrease() {
        return this._data.percentageIncrease;
    }
    get additionalData() {
        return this._data.additionalData;
    }
    get additionalLines() {
        return this._data.additionalLines;
    }
}
